import LocalForage from 'localforage'
import SessionStorageWrapper from 'localforage-sessionstoragewrapper'

/*
 * Defines the data structure for local storage.
 */
export default class LocalDatabase {

    /**
     * Creates an instance of LocalDatabase.
     * @param {string} storeName The table name to store data under. This becomes the LocalForage database name.
     * @memberof LocalDatabase
     */
    constructor(storeName = 'context', useSessionStorage = false) {

        this[storeName] = LocalForage.createInstance({
            name: 'pp-household',
            storeName,
        })

        if (useSessionStorage && this[storeName] && this[storeName].defineDriver)
            this[storeName].defineDriver(SessionStorageWrapper).then(() => this[storeName].setDriver(SessionStorageWrapper._driver))
    }
}
